export enum VisitType {
  InPerson = 1,
  Telemedicine = 2,
  Both = 3,
}
